<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/TechnicalServices.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb class="el-icon-arrow-right" separator-class="el-icon-arrow-right">
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>技术服务</el-breadcrumb-item>
          <el-breadcrumb-item>{{ tabName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="information index_center">
      <div class="information_right">
        <div class="information_left">
          <div class="TechnicalBar">
            <el-menu class="el-menu-vertical-demo" mode="horizontal" active-text-color="#2968BD"
              :default-active="tabIndex + ''">
              <el-menu-item v-for="(item, index) in serviceTypeList" :index="index + ''" :key="item.id"
                @click="ChangeItem(`${index}`)">
                <span slot="title">{{ item.serviceType }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="CloudService">
          <div class="CloudService_title">
            <el-divider>
              <div id="maodiaoText" class="CloudService_title_name">{{ tabName }}</div>
            </el-divider>
          </div>
          <div class="CloudService_content">
            <span v-if="content" v-html="content"></span>
            <el-empty v-else description="暂无相关文章"></el-empty>
          </div>
        </div>
      </div>
      <SubmitFrom></SubmitFrom>
    </div>
    <Foot style="margin-top: 120px" @goRouter="goRouter"></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";

import { getServiceTypeApi, getServiceInfoApi } from "@/api/index";

export default {
  components: {
    Nav,
    Foot,
    SubmitFrom,
  },
  name: "Information",
  data() {
    return {
      tabIndex: 0,
      serviceTypeList: [],
      content: "",
      tabName: "",
      temp: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getServiceType();
    })
    this.$cookies.set("tabbar", 3);
    this.$store.state.tabbar = this.$cookies.get("tabbar");

  },
  beforeUpdate() {
    //接收参数index
    if (!this.temp) {
      this.tabIndex = this.$route.query.index ? this.$route.query.index : 0
      if (this.$route.query.tabName) {
        this.tabName = JSON.parse(this.$route.query.tabName)
      } else {
        this.tabName = this.serviceTypeList[this.tabIndex].serviceType
      }
      this.getServiceInfo();
    } else {
      this.tabName = this.serviceTypeList[this.tabIndex].serviceType
      this.getServiceInfo();

    }
  },
  methods: {
    goRouter(index) {
      this.tabIndex = index;
      this.getServiceInfo();
    },
    //serve页面点击修改文字
    ChangeItem(index) {
      this.temp = true;
      this.tabName = this.serviceTypeList[index].serviceType;
      this.tabIndex = index;
    },
    //获取服务类型
    getServiceType() {
      getServiceTypeApi().then((res) => {
        // console.log("服务类型列表", res);
        this.serviceTypeList = res.data;
        if (this.$route.query.tabIndex) {
          this.tabIndex = this.$route.query.tabIndex;
          this.tabName = this.$route.query.tabName ? JSON.parse(this.$route.query.tabName) : this.serviceTypeList[this.tabIndex].serviceType;
        } else {
          this.tabIndex = 0;
          this.tabName = this.serviceTypeList[0].serviceType;
        }
      });
    },
    //获取服务详情
    getServiceInfo() {
      // console.log("服务详情", this.tabIndex);
      var data = {
        type: this.serviceTypeList[this.tabIndex].id,
      };
      getServiceInfoApi(data).then((res) => {
        this.content = res.data ? res.data.content : '';
      });
    },
  },
};
</script>

<style scoped>
.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 60px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
  width: 210px !important;
}

.index_center {
  width: 1200px;
  /*width: 1360px;*/
  margin: 0 auto;
}

.information {
  /*margin-top: 70px;*/
  display: flex;
}

.information_left {
  /*width: 140px;*/
  padding-top: 30px;
}

.information_right {
  padding-top: 60px;
  display: flex;
  justify-content: center;
  width: 1200px;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}

.el-icon-arrow-right {
  display: flex;
  align-items: center;
  /*width: 1360px;*/
  width: 1200px;
  color: #666666;
}

.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el_form {
  width: 700px;
}

div /deep/ .el-textarea__inner {
  height: 200px;
  width: 495px;
}

.CloudService {
  padding-left: 65px;
  width: 100%;
}

.CloudService_title {
  /*font-size: 28px;*/
  /*font-weight: 600;*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 70px;
  /*width: 1025px;*/
  width: 100%;
}

.CloudService_title_name {
  font-size: 28px;
  text-align: center;
  font-weight: 600;
}

.CloudService_title_text {
  font-size: 14px;
  text-align: center;
}

.CloudService_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CloudService_content /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px auto;
}

.CloudService_content_span {
  width: 730px;
  padding: 28px 0;
  line-height: 24px;
}

.CloudService_content_img {
  width: 730px;
  height: 410px;
}

.CloudService_content_img img {
  width: 100%;
  height: 100%;
}

.TechnicalBar>>>.el-menu--horizontal>.el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
  /*background-color: red;*/
  background-image: linear-gradient(to right, #ffffff, rgba(41, 104, 189, 0.1));
}

.TechnicalBar>>>.el-menu--horizontal>.el-menu-item {
  border-bottom: none;
  /*text-align: center;*/
  width: 140px;
}

.TechnicalBar>>>.el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue